"use client";

import Register from "@/components/auth/Register";
import { useParams, useSearchParams } from "next/navigation";
import type { SupportedLanguage } from "@/lib/shared";
import { resolveLocale } from "@/lib/resolvedLocale";

export default function RegisterPageRoute() {
  const params = useParams();
  const search = useSearchParams();
  const locale: SupportedLanguage = resolveLocale(params.locale as string | undefined);
  const tab = search.get("tab") || "email";

  return <Register locale={locale} tab={tab} />;
}
